var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.panel || 'DIV',{tag:"component",staticStyle:{"height":"100%"}},[_vm._t("default",function(){return [_vm._v(" 静态面板 "),_c('div',[_vm._v(_vm._s(_vm.value))]),_c('div',[_vm._v(_vm._s(_vm.type))]),_c('div',[_vm._v(_vm._s(_vm.config))]),_c('div',[_vm._v(_vm._s(_vm.dataconfig))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }